module.exports = __webpack_public_path__ + "img/arrow-right.9b0aec50.svg";